/**
 * Root Component
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import IntlWrapper from './modules/Intl/IntlWrapper';

// Import Routes
import Routes from './routes';


export default function App(props) {
    return (
        <IntlWrapper>
            <Router>
                <Routes />
            </Router>
        </IntlWrapper>

    );
}

App.propTypes = { store: PropTypes.object.isRequired };
